import React from 'react';
import { Hero } from '../components/Hero';
import { Legacy } from '../components/Legacy';
import { CompetencyGrid } from '../components/CompetencyGrid';
import { StrategicMap } from '../components/StrategicMap';
import { CapabilityStatement } from '../components/CapabilityStatement';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function Home() {
  return <PageWrapper data-id="element-593">
      <Hero data-id="element-594" />
      <SectionWrapper data-id="element-595">
        <Legacy data-id="element-596" />
      </SectionWrapper>
      <SectionWrapper data-id="element-597">
        <CompetencyGrid data-id="element-598" />
      </SectionWrapper>
      <SectionWrapper data-id="element-599">
        <StrategicMap data-id="element-600" />
      </SectionWrapper>
      <SectionWrapper data-id="element-601">
        <CapabilityStatement data-id="element-602" />
      </SectionWrapper>
    </PageWrapper>;
}